var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ClassList" },
    [
      _c("filters"),
      _vm._v(" "),
      _vm.classList && _vm.classList.length
        ? [
            _c(
              "div",
              { staticClass: "d-flex justify-content-center" },
              _vm._l(_vm.classesMatrix, function(cartColumn, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "w-100 mx-1" },
                  _vm._l(cartColumn, function(activity) {
                    return _c(
                      "div",
                      { key: activity.id, staticClass: "mb-4" },
                      [
                        _c("class-cart", {
                          attrs: {
                            activity: activity,
                            "is-public": _vm.isPublic
                          },
                          on: {
                            open: function($event) {
                              return _vm.onEnrollButtonClick(activity)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("pagination")
          ]
        : [
            !_vm.searchQuery
              ? _c("no-data-skeleton")
              : [
                  _c("div", { staticClass: "not-found" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../assets/img/ilustra-empty-search.png")
                      }
                    }),
                    _vm._v(
                      "\n                Oh no! We can’t find any activities with that name :|\n            "
                    )
                  ])
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d159f6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d159f6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/pages/Activities/ClassList.vue
// module id = null
// module chunks = 